import { render, staticRenderFns } from "./slidePreview.vue?vue&type=template&id=064b006c"
import script from "./slidePreview.vue?vue&type=script&lang=js"
export * from "./slidePreview.vue?vue&type=script&lang=js"
import style0 from "./slidePreview.vue?vue&type=style&index=0&id=064b006c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports